import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { driverSchema } from '../schemas/driver.schema';

/**
 * Requests a specific Driver
 * @param driverId The ID of the Driver being requested
 * @returns The Driver
 */
export function getDriversId(this: unknown, driverId: string) {
  const requestUrl = `${fleetEnvironment.resolve(this).driversUrl}/${driverId}`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(driverSchema));
}
